import WhatIfMenu from './WhatIfMenu/WhatIfMenuContainer';
import RetirementAges from './Retirement/General/RetirementAgesContainer';
import LifeExpectancies from './Retirement/General/LifeExpectanciesContainer';
import RetirementExpenses from './Retirement/General/RetirementExpensesContainer';
import AdditionalSavings from './AdditionalSavings/AdditionalSavingsContainer';
import Distributions from './Retirement/Distributions/DistributionsContainer';
import AssetAllocationPre from './AssetAllocations/AssetAllocationPreContainer';
import AssetAllocationPost from './AssetAllocations/AssetAllocationPostContainer';
import AssetAllocation from './AssetAllocations/AssetAllocationContainer';
import MonthlyBenefits from './Retirement/SocialSecurity/MonthlyBenefitsContainer';
import InflationChanges from './Retirement/StressTest/InflationChangesContainer';
import MarketDrops from './Retirement/StressTest/MarketDropsContainer';
import AllPlanEdits from './AllPlanEdits/AllPlanEditsContainer';
import TargetAmount from './EmergencyFund/General/TargetAmount/TargetAmountContainer';
import GoalYear from './EmergencyFund/General/GoalYear/GoalYearContainer';
import DownPayment from './HomePurchase/General/DownPayment/DownPaymentContainer';
import PurchaseYear from './HomePurchase/General/PurchaseYear/PurchaseYearContainer';
import MortgageType from './HomePurchase/General/MortgageType/MortgageTypeContainer';
import MortgageInterestRate from './HomePurchase/General/MortgageInterestRate/MortgageInterestRateContainer';
import HomeValue from './HomePurchase/General/HomeValue/HomeValueContainer';
import TaxRates from './HomePurchase/Assumptions/TaxRates/TaxRatesContainer';
import PMI from './HomePurchase/Assumptions/PMI/PMIContainer';
import HomeInsurance from './HomePurchase/Assumptions/HomeInsurance/HomeInsuranceContainer';
import HOA from './HomePurchase/Assumptions/HOA/HOAContainer';
import HealthCareGoalYear from './HealthCare/General/GoalYear/GoalYearContainer';
import HealthCareCost from './HealthCare/General/Cost/CostContainer';
import HealthCareInflation from './HealthCare/General/Inflation/InflationContainer';
import DebtManagementStrategy from './DebtManagement/Strategy/StrategyContainer';
import DebtManagementRefinance from './DebtManagement/Refinance/RefinanceContainer';
import SchoolType from './Education/General/SchoolTypeContainer';
import SchoolYears from './Education/General/SchoolYearsContainer';
import PriceChanges from './LargePurchase/General/PriceChangesContainer';
import PurchaseFrequency from './LargePurchase/General/PurchaseFrequencyContainer';
import LargePurchaseGoalYear from './LargePurchase/General/GoalYearContainer';
import LifeInsuranceLivingExpenses from './Insurance/LifeInsurance/LivingExpensesContainer';
import LifeInsuranceEmploymentIncome from './Insurance/LifeInsurance/EmploymentIncomeContainer';
import LifeInsuranceCoverageContainer from './Insurance/LifeInsurance/CoverageContainer';
import LtcAdditionalCoverage from './Insurance/LongTermCare/LtcAdditionalCoverageContainer';
import LtcCost from './Insurance/LongTermCare/LtcCostContainer';
import LtcNeeds from './Insurance/LongTermCare/LtcNeedsContainer';
import DecumulationDistributionAmount from './Decumulation/DistributionAmount/DistributionAmount.container';
import DecumulationDistributionYears from './Decumulation/DistributionYears/DistributionYears.container';

import {
  ALL_PLAN_EDITS,
  RETIREMENT_MENU,
  EDUCATION_MENU,
  HOME_PURCHASE_MENU,
  LARGE_PURCHASE_MENU,
  HEALTHCARE_MENU,
  DEBT_MANAGEMENT_MENU,
  EMERGENCY_FUND_MENU,
  EMERGENCY_FUND_GENERAL_TARGET_AMOUNT,
  EMERGENCY_FUND_GENERAL_GOAL_YEAR,
  RETIREMENT_GENERAL_AGES,
  RETIREMENT_GENERAL_EXPENSES,
  RETIREMENT_GENERAL_LIFE_EXPECTANCIES,
  RETIREMENT_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS,
  RETIREMENT_DISTRIBUTIONS_DISTRIBUTIONS,
  RETIREMENT_ASSET_ALLOCATIONS_ASSET_ALLOCATION_PRE,
  RETIREMENT_ASSET_ALLOCATIONS_ASSET_ALLOCATION_POST,
  RETIREMENT_SOCIAL_SECURITY_MONTHLY_BENEFITS,
  RETIREMENT_STRESS_TEST_INFLATION_CHANGES,
  RETIREMENT_STRESS_TEST_MARKET_DROPS,
  EDUCATION_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS,
  LARGE_PURCHASE_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS,
  EMERGENCY_FUND_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS,
  HEALTH_CARE_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS,
  HOME_PURCHASE_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS,
  DEBT_MANAGEMENT_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS,
  EDUCATION_ASSET_ALLOCATIONS_ASSET_ALLOCATION,
  LARGE_PURCHASE_ASSET_ALLOCATIONS_ASSET_ALLOCATION,
  HEALTH_CARE_ASSET_ALLOCATIONS_ASSET_ALLOCATION,
  HOME_PURCHASE_ASSET_ALLOCATIONS_ASSET_ALLOCATION,
  HOME_PURCHASE_GENERAL_DOWN_PAYMENT,
  HOME_PURCHASE_GENERAL_PURCHASE_YEAR,
  HOME_PURCHASE_GENERAL_MORTGAGE_TYPE,
  HOME_PURCHASE_GENERAL_HOME_VALUE,
  HOME_PURCHASE_ASSUMPTIONS_TAX_RATES,
  HOME_PURCHASE_ASSUMPTIONS_PMI,
  HOME_PURCHASE_ASSUMPTIONS_HOME_INSURANCE,
  HOME_PURCHASE_ASSUMPTIONS_HOA,
  HEALTH_CARE_GENERAL_YEAR,
  HEALTH_CARE_GENERAL_PRICE,
  HEALTH_CARE_GENERAL_INFLATION,
  HOME_PURCHASE_GENERAL_MORTGAGE_INTEREST_RATE,
  DEBT_MANAGEMENT_STRATEGY_REPLAYMENT,
  DEBT_MANAGEMENT_REFINANCE,
  EDUCATION_GENERAL_SCHOOL_TYPE,
  EDUCATION_GENERAL_SCHOOL_YEARS,
  LARGE_PURCHASE_GENERAL_GOAL_YEAR,
  LARGE_PURCHASE_GENERAL_PRICE_CHANGES,
  LARGE_PURCHASE_GENERAL_PURCHASE_FREQUENCY,
  LIFE_INSURANCE_MENU,
  LONG_TERM_CARE_INSURANCE_MENU,
  INSURANCE_LIFE_LIFE_INSURANCE_LIVING_EXPENSES,
  INSURANCE_LIFE_LIFE_INSURANCE_EMPLOYMENT_INCOME,
  INSURANCE_LIFE_LIFE_INSURANCE_COVERAGE,
  INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_NEEDS,
  INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_COST,
  INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_ADDITIONAL_COVERAGE,
  RETIREMENT_ROTH_CONVERSION,
  PROFILE_CHANGES_BUSINESS_SALE,
  PROFILE_CHANGES_REAL_ESTATE_SALE,
  PROFILE_CHANGES_MISC_ASSET_SALE,
  PROFILE_CHANGES_INCOME_CHANGE,
  DECUMULATION_MENU,
  DECUMULATION_DISTRIBUTION_AMOUNT,
  DECUMULATION_DISTRIBUTION_YEARS,
  ESTATE_PLANNING_MENU,
  ESTATE_PLANNING_TAX_RATES,
  ESTATE_PLANNING_LIFE_EXPECTANCIES,
  ESTATE_PLANNING_CHARITABLE_DONATIONS,
  ANNUITY_PURCHASE,
  WINDFALL,
} from './WhatIfsConstants';
import RothConversionWhatIf from './Retirement/RothConversion/RothConversionContainer';
import {
  BusinessSale,
  EstatePlanningCharitableDonations,
  EstatePlanningLifeExpectancies,
  EstateTaxesChange,
  IncomeChange,
  MiscAssetSale,
  RealEstateSale,
  AnnuityPurchase,
  Windfall,
} from './NewWhatIfsBridge';

export default {
  [RETIREMENT_MENU]: WhatIfMenu,
  [EDUCATION_MENU]: WhatIfMenu,
  [HOME_PURCHASE_MENU]: WhatIfMenu,
  [LARGE_PURCHASE_MENU]: WhatIfMenu,

  [HOME_PURCHASE_GENERAL_DOWN_PAYMENT]: DownPayment,
  [HOME_PURCHASE_GENERAL_PURCHASE_YEAR]: PurchaseYear,
  [HOME_PURCHASE_GENERAL_MORTGAGE_TYPE]: MortgageType,
  [HOME_PURCHASE_GENERAL_MORTGAGE_INTEREST_RATE]: MortgageInterestRate,
  [HOME_PURCHASE_GENERAL_HOME_VALUE]: HomeValue,
  [HOME_PURCHASE_ASSUMPTIONS_TAX_RATES]: TaxRates,
  [HOME_PURCHASE_ASSUMPTIONS_PMI]: PMI,
  [HOME_PURCHASE_ASSUMPTIONS_HOME_INSURANCE]: HomeInsurance,
  [HOME_PURCHASE_ASSUMPTIONS_HOA]: HOA,
  [HEALTHCARE_MENU]: WhatIfMenu,
  [HEALTH_CARE_GENERAL_YEAR]: HealthCareGoalYear,
  [HEALTH_CARE_GENERAL_PRICE]: HealthCareCost,
  [HEALTH_CARE_GENERAL_INFLATION]: HealthCareInflation,
  [DEBT_MANAGEMENT_MENU]: WhatIfMenu,
  [DEBT_MANAGEMENT_STRATEGY_REPLAYMENT]: DebtManagementStrategy,
  [DEBT_MANAGEMENT_REFINANCE]: DebtManagementRefinance,
  [EMERGENCY_FUND_MENU]: WhatIfMenu,
  [EMERGENCY_FUND_GENERAL_TARGET_AMOUNT]: TargetAmount,
  [EMERGENCY_FUND_GENERAL_GOAL_YEAR]: GoalYear,
  [RETIREMENT_GENERAL_AGES]: RetirementAges,
  [RETIREMENT_GENERAL_LIFE_EXPECTANCIES]: LifeExpectancies,
  [RETIREMENT_GENERAL_EXPENSES]: RetirementExpenses,
  [RETIREMENT_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS]: AdditionalSavings,
  [EDUCATION_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS]: AdditionalSavings,
  [LARGE_PURCHASE_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS]: AdditionalSavings,
  [EMERGENCY_FUND_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS]: AdditionalSavings,
  [HEALTH_CARE_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS]: AdditionalSavings,
  [HOME_PURCHASE_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS]: AdditionalSavings,
  [DEBT_MANAGEMENT_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS]: AdditionalSavings,
  [EDUCATION_ASSET_ALLOCATIONS_ASSET_ALLOCATION]: AssetAllocation,
  [LARGE_PURCHASE_ASSET_ALLOCATIONS_ASSET_ALLOCATION]: AssetAllocation,
  [HEALTH_CARE_ASSET_ALLOCATIONS_ASSET_ALLOCATION]: AssetAllocation,
  [HOME_PURCHASE_ASSET_ALLOCATIONS_ASSET_ALLOCATION]: AssetAllocation,
  [RETIREMENT_DISTRIBUTIONS_DISTRIBUTIONS]: Distributions,
  [RETIREMENT_ASSET_ALLOCATIONS_ASSET_ALLOCATION_PRE]: AssetAllocationPre,
  [RETIREMENT_ASSET_ALLOCATIONS_ASSET_ALLOCATION_POST]: AssetAllocationPost,
  [RETIREMENT_SOCIAL_SECURITY_MONTHLY_BENEFITS]: MonthlyBenefits,
  [RETIREMENT_STRESS_TEST_INFLATION_CHANGES]: InflationChanges,
  [RETIREMENT_STRESS_TEST_MARKET_DROPS]: MarketDrops,
  [RETIREMENT_ROTH_CONVERSION]: RothConversionWhatIf,
  [EDUCATION_GENERAL_SCHOOL_TYPE]: SchoolType,
  [EDUCATION_GENERAL_SCHOOL_YEARS]: SchoolYears,
  [LARGE_PURCHASE_GENERAL_GOAL_YEAR]: LargePurchaseGoalYear,
  [LARGE_PURCHASE_GENERAL_PRICE_CHANGES]: PriceChanges,
  [LARGE_PURCHASE_GENERAL_PURCHASE_FREQUENCY]: PurchaseFrequency,
  [LIFE_INSURANCE_MENU]: WhatIfMenu,
  [LONG_TERM_CARE_INSURANCE_MENU]: WhatIfMenu,

  [INSURANCE_LIFE_LIFE_INSURANCE_LIVING_EXPENSES]: LifeInsuranceLivingExpenses,
  [INSURANCE_LIFE_LIFE_INSURANCE_EMPLOYMENT_INCOME]: LifeInsuranceEmploymentIncome,
  [INSURANCE_LIFE_LIFE_INSURANCE_COVERAGE]: LifeInsuranceCoverageContainer,
  [INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_NEEDS]: LtcNeeds,
  [INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_COST]: LtcCost,
  [INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_ADDITIONAL_COVERAGE]: LtcAdditionalCoverage,

  [ALL_PLAN_EDITS]: AllPlanEdits,

  [PROFILE_CHANGES_BUSINESS_SALE]: BusinessSale,
  [PROFILE_CHANGES_REAL_ESTATE_SALE]: RealEstateSale,
  [PROFILE_CHANGES_MISC_ASSET_SALE]: MiscAssetSale,
  [PROFILE_CHANGES_INCOME_CHANGE]: IncomeChange,

  [DECUMULATION_MENU]: WhatIfMenu,
  [DECUMULATION_DISTRIBUTION_AMOUNT]: DecumulationDistributionAmount,
  [DECUMULATION_DISTRIBUTION_YEARS]: DecumulationDistributionYears,

  [ESTATE_PLANNING_MENU]: WhatIfMenu,
  [ESTATE_PLANNING_TAX_RATES]: EstateTaxesChange,
  [ESTATE_PLANNING_LIFE_EXPECTANCIES]: EstatePlanningLifeExpectancies,
  [ESTATE_PLANNING_CHARITABLE_DONATIONS]: EstatePlanningCharitableDonations,

  [ANNUITY_PURCHASE]: AnnuityPurchase,
  [WINDFALL]: Windfall,
};
